module.exports = __webpack_public_path__ + "static/media/visit_website_img.4be3d649.svg";